var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view'),_c('Footer'),_c('NotFound')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-custom"},[_c('div',{staticClass:"block_bg"})])
}]

export { render, staticRenderFns }